module.exports = __webpack_public_path__ + "media/promotional/racing-d8fbc60a.jpeg";